import { render, staticRenderFns } from "./WebsiteFinance.vue?vue&type=template&id=2a5bb41a"
import script from "./WebsiteFinance.vue?vue&type=script&lang=js"
export * from "./WebsiteFinance.vue?vue&type=script&lang=js"
import style0 from "./WebsiteFinance.vue?vue&type=style&index=0&id=2a5bb41a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports